var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"device-on-warning-modal","title":_vm.$t('app.deviceOnWarningModal.title'),"ok-title":_vm.$t('app.deviceOnWarningModal.ok'),"header-text-variant":"light","header-bg-variant":"warning","ok-variant":"warning","ok-only":"","centered":""}},[_vm._v("\n  "+_vm._s(_vm.$t('app.deviceOnWarningModal.message'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }